import React, {useContext, useEffect} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';

function CatReasonsEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabClose=actions.tabClose

    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const update=(d)=>{
        //return
        let newData={...wndData,...d.data,changed:false}
        setWndData(newData)
        //tabClose()
    }
    
    const saveValue=(act)=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const can_use=parseInt(wndData.use_kitch||0)*2+parseInt(wndData.use_offic||0)
        const no_product=parseInt(wndData.no_prod)?1+parseInt(wndData.prn_ret||0):0

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'CatReasons',data:{name,can_use,no_product}}
                saveData(newData,d=>act(d))
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'CatReasons',data:{id,name,can_use,no_product}}
                saveData(newData,d=>act(d))
            }        
        }

    }

    useEffect(() => {
        if (context.data['catReasons'] === undefined) {
            context.getData('catReasons')
        } 
    },)

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',alignSelf:'flex-start',flexGrow:'10000'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
    <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='44' width2='50' disabled={true}/>
    <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
    <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='52' width2='182'/>
        </div>
    <EditCtrl Capt={localestr('Доступно для вибору офіціанту')} Value={wndData.use_offic} typeVal={'check'} setVal={(d)=>{setValue('use_offic',d)}} width1='330' width2='13'/>
    <EditCtrl Capt={localestr('Доступно для вибору кухні')} Value={wndData.use_kitch} typeVal={'check'} setVal={(d)=>{setValue('use_kitch',d)}} width1='330' width2='13'/>
    <EditCtrl Capt={localestr('Без списання інгредієнтів')} Value={wndData.no_prod} typeVal={'check'} setVal={(d)=>{setValue('no_prod',d)}} width1='330' width2='13'/>
    {parseInt(wndData.no_prod)?<EditCtrl Capt={localestr('Друк відмови на кухні')} Value={wndData.prn_ret} typeVal={'check'} setVal={(d)=>{setValue('prn_ret',d)}} width1='330' width2='13'/>:null}

    <div style={{margin:'10px 0 0 0',width:'337px',display:'flex',justifyContent:'center'}}>
    <div style={{width:'60px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(tabClose)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    <div style={{width:'90px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue(update)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Зберегти')}</div></div>
    </div>
    </div>
    )
    
}

export default CatReasonsEdit